module.exports = __webpack_public_path__ + "img/sdg_es_(1).a4ffc7d5.png";